import React from 'react';
import PropTypes from 'prop-types';
import { unitAndEst } from '../../utils/est';
import T from './T';

export default class extends React.PureComponent {
  static contextTypes = {
    formatters: PropTypes.object
  };

  state = {
    now: Date.now(),
    load: Date.now(),
  };

  componentDidMount() {
    this.counter = setInterval(() => {
      this.setState({ now: Date.now() });
    }, 1000);
  }

  componentWillUnmount() {
    if (this.counter) {
      clearInterval(this.counter);
      this.counter = null;
    }
  }

  render() {
    const { deadline, reloadOnFinish = true } = this.props;
    const { now } = this.state;
    const { formatters } = this.context;
    const { unit, est } = unitAndEst(deadline, now);

    const deadlineStamp = new Date(deadline).getTime();
    const expiredOnLoad = this.state.load > deadlineStamp;
    if (expiredOnLoad) {
      return (
        <T msg="donation.finished" />
      );
    }

    if (reloadOnFinish && est <= 0) {
      if (!expiredOnLoad) {
        window.location.reload();
        return null;
      }
    }

    let msg;

    switch (unit) {
      case 'days':
        msg = 'donation.estDays';
        break;

      case 'hours':
        msg = 'donation.estHours';
        break;

      case 'minutes':
        msg = 'donation.estMinutes';
        break;

      default:
        msg = 'donation.estSeconds';
    }

    return (
      <T msg={msg} count={est} countFormatted={formatters.formatNumber(est)} />
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/EstCounter.js